import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const readonlyDropdownOptionStyle = css`
  margin-bottom: ${theme.spacing(0)};
  height: 30px;

  > div {
    opacity: 0.7;
  }
  > label {
    opacity: unset;
    flex: 1;
    overflow: hidden;
  }
`;

export const readonlyDropdownContainerStyle = css`
  margin-bottom: ${theme.spacing(3)};
`;

export const labelStyle = css`
  flex: 1;
  overflow: hidden;
  > span {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
